import React, { useRef, useState } from 'react';
import { 
  Box,
  Button,
  Stack,
  IconButton
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import PrintIcon from '@mui/icons-material/Print';
import { useReactToPrint } from 'react-to-print';
import EndOfDayReport from './EndofDayReport';
import {enGB} from 'date-fns/locale';
import { useAppContext } from '../AppContext';

const EndofDayReportContainer = ({ shopId }) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [key, setKey] = useState(0);
  const reportRef = useRef();
  const { t } = useAppContext();

  const handlePrint = useReactToPrint({
    content: () => reportRef.current,
  });

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
    setKey(prevKey => prevKey + 1);
  };

  return (
    <Box>
      <Stack 
        direction="row" 
        spacing={2} 
        sx={{ mb: 3 }}
        justifyContent="flex-end"
      >
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
          <DatePicker
            label={t("Select Date")}
            value={selectedDate}
            onChange={handleDateChange}
            sx={{ width: 200 }}
          />
        </LocalizationProvider>
        <Button
          variant="contained"
          startIcon={<PrintIcon />}
          onClick={handlePrint}
        >
          {t("Print Report")}
        </Button>
      </Stack>
      <EndOfDayReport 
        ref={reportRef}
        key={key}
        shopId={shopId}
        date={selectedDate}
      />
    </Box>
  );
};

export default EndofDayReportContainer;
